import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { CMDiv } from '../login/login.styles';
import InputField from '../../../components/Input-field/input-field.component';
import Button, { BUTTON_TYPE_CLASSES } from '../../../components/button/button.component';
import Alert, { ALERT_TYPE } from '../../../components/alert/alert.component';
import { useEffect, useState } from 'react';
import Heading from '../../../components/heading/heading.component';
import { useLocation, useNavigate } from 'react-router-dom';
import { user_changepass, user_forgetpass } from '../../../Services/prod/auth.service';
import { ButtonsContainer } from './reset-password.styles';

const passwordValidationRules = [
  {
    rule: (value) => value.length >= 8,
    message: "8 Characters",
  },
  {
    rule: (value) => value.length <= 30,
    message: "Max 30 characters",
  },
  {
    rule: (value) => /^(?=.*[A-Za-z])/.test(value),
    message: "1 Letter",
  },
  {
    rule: (value) => /^(?=.*\d)/.test(value),
    message: "1 Number",
  },
  {
    rule: (value) => /^(?=.*[a-z])/.test(value),
    message: "1 Lowercase",
  },
  {
    rule: (value) => /^(?=.*[A-Z])/.test(value),
    message: "1 Uppercase",
  },
  {
    rule: (value) => /^(?=.*[@$!%*#?&/^*_-])/.test(value),
    message: "1 Special character",
  },
];

const ResetPassword = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('');
  const [countdown, setCountdown] = useState(0);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userStatus, setUserStatus] = useState('')
  const [statusEmail, setStatusEmail] = useState('')
  const [initialValues] = useState({
    code: '',
    password: '',
    confirm_pass: ''
  })

  const { state } = useLocation();
  const [email, setEmail] = useState('');

  useEffect(() => {
    if (state && state.email) {
      setEmail(state.email);
    }
  }, [state])

  const validationSchema = Yup.object({
    code: Yup.string().required('Verification code is required'),
    password: Yup.string()
      .required('Password is required')
      .transform((originalValue, originalObject) => {
        const trimmedValue = originalValue.trim()
        if (trimmedValue === '') {
          throw new Yup.ValidationError(
            'Password cannot be empty',
            originalValue,
            'password'
          );
        }
        const errors = passwordValidationRules
          .filter((rule) => !rule.rule(trimmedValue))
          .map((rule) => rule.message);
        if (errors.length > 0) {
          if (errors.length === 1) {
            throw new Yup.ValidationError(
              errors[0], 
              originalValue,
              'password'
            );
          } else {
            throw new Yup.ValidationError(
              errors.join(', ').replace(/,\s*$/, ''), 
              originalValue,
              'password'
            );
          }
        }
        return originalValue; 
      }),
    confirm_pass: Yup.string()
      .required('Please confirm your password')
      .test('passwords-match', "Passwords don't match", function (value) {
        const { password } = this.parent;
        return value === password || !password;
      }),
  });

  useEffect(() => {
    let timer;
    if (countdown > 0) {
        timer = setInterval(() => {
            setCountdown(prev => prev - 1);
        }, 1000);
    } else {
        setIsButtonDisabled(false);
    }
    return () => clearInterval(timer);
  }, [countdown]);

  const sendAgain = () => {
    setUserStatus('');
    setIsButtonDisabled(true);
    setLoading(true);
    setCountdown(60); 
    try {
      if (email) {
        user_forgetpass(email).then(data => {
          if (data && data.isSuccess === true) {
            setUserStatus("Email sent.");
            setTimeout(() => {
              setUserStatus('');
            }, 5000);
          }
          else {
            setStatusEmail(data.message);
          }
        }).finally(() => {
          setLoading(false);
      });
      }
    } catch (error) {
      console.error(error);
    }
  }

  const handleSubmit = (values) => {
    user_changepass(email, values.code, values.password).then(data => {
      if (data && data.isSuccess) {
        navigate('/auth', { state: { verified: true } });
      }
      else {
        setStatus(data.message);
      }
    })
  }

  return (
    <div className="App">
      <Heading previusPage={'Reset Password'} />
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={values => handleSubmit(values)}>

        {({ values, errors, touched }) => {
          return (
            <>
              <CMDiv>
                {status &&
                  <Alert alertType={ALERT_TYPE.error}>{status}</Alert>
                }
                <Form id='SignUp' autoComplete='false'>
                  <div className='form-container'>
                    <div className='form-control'>
                      <InputField name='code' id='code' placeholder='Verification Code' isInvalid={errors.code && touched.code} error={errors.code} style={{ width: 'auto' }} />
                    </div>
                    <div className='form-control'>

                      <InputField
                        type="password"
                        name="password"
                        id="password"
                        placeholder='Password'
                        isInvalid={!!errors.password && (touched.password || values.password.length > 0)}
                        error={errors.password}
                        autoComplete="new-password"
                      />

                    </div>
                    <div className='form-control'>
                      <InputField name='confirm_pass' id='confirm_pass' type="password" placeholder='' isInvalid={errors.confirm_pass && touched.confirm_pass} error={errors.confirm_pass} />
                    </div>
                  </div>
                  <ButtonsContainer>
                    <div className="buttonSendReset">
                      <Button type='submit' className="buttonSendReset">Send</Button>
                    </div>
                    <div>
                      <label className="buttonSendReset" >Did not receive the code?</label>
                    </div>
                    <div>
                      <Button disabled={isButtonDisabled || loading} type="button" className="resend_code_button" buttonType={BUTTON_TYPE_CLASSES.TextButton} color="blue" onClick={sendAgain}>Send Again</Button>
                    </div>
                    {isButtonDisabled && (
                      <p>
                        Try again in {countdown} seconds
                      </p>
                    )}
                  </ButtonsContainer>
                </Form>
              </CMDiv>
            </>
          )
        }}

      </Formik>
    </div>
  )
}

export default ResetPassword;